import { Attendee } from "@lib/store/src/data/timeslots/selectors/getAttendeeOverview";
import { UserCell, RSVP } from "@molecules";
import { differenceInDays } from "date-fns";
import { useTranslation } from "react-i18next";

export const AttendeeCell = ({ attendee }: { attendee: Attendee }) => {
  const { t } = useTranslation();

  const rsvpStatus = attendee.isOrganizer
    ? "Organizer"
    : attendee.reservation.status === "Confirmed"
      ? "Accepted"
      : attendee.reservation.status === "InvitationPending"
        ? "Pending"
        : "Declined";

  const daysToRSVP = attendee.reservation.expiryDate
    ? differenceInDays(new Date(attendee.reservation.expiryDate), new Date())
    : -1;

  const subtitle =
    attendee.reservation.status === "Confirmed"
      ? attendee.reservation.workspace.nodeName
      : attendee.reservation.status !== "InvitationPending"
        ? undefined
        : daysToRSVP < 0
          ? `` // Expired label?
          : daysToRSVP === 0
            ? t("workplace:FinalDayToRespond")
            : t("workplace:DayToRespond", { count: daysToRSVP });

  return (
    <UserCell
      separator={false}
      padding="small"
      user={attendee.isCurrentUser ? { ...attendee.owner, displayName: t("translation:You") } : attendee.owner}
      right={<RSVP rsvp={rsvpStatus} />}
      subtitle={subtitle}
    />
  );
};
